import { useEffect } from 'react';

export const useScrollToTop = (id?: string, deps?: any[]): void => {
  useEffect(() => {
    const container = id && document.getElementById(id);

    if (container) {
      container.scroll({ top: 0, behavior: 'auto' });
    }
  }, deps);
};
